<template>
  <vueAceEditor v-model="source" @init="editorInit" @input="change" :lang="language" :theme="theme" :width="width" :height="height" :style="style"></vueAceEditor>
</template>

<script>
import vueAceEditor from 'vue2-ace-editor';
var Range = ace.acequire('ace/range').Range

const ACE_LANG = "javascript";
const ACE_THEME = "monokai";

export default {
  name: 'aceEditor',
  props:{
      initialSource: {
        type: String,
        default: ""
      },
      height: {
        default: "100px",
        type: String
      },
      width: {
        default: "100%",
        type: String
      },
      style: {
        default: "",
        type: String
      },
      breakpoints: {
         default: true,
         type: Boolean
      }
  },
  data() {
    return {
      theme: ACE_THEME,
      language: ACE_LANG,
      source: ""
    }
  },
  components: {
    vueAceEditor
  },
  methods:{
        // Initialization
        editorInit(editor) {
            var self = this;
            this.editor = editor;
            // load language and theme
            console.log(this.language)
            require('brace/mode/' + ACE_LANG);
            require('brace/theme/' + ACE_THEME);
            // disable syntax check
            this.editor.getSession().setUseWorker(false);

            if (this.initialSource) {
              this.setSource(this.initialSource)
            }

            // Breakpoint toggling callback.
            // Inspired by http://stackoverflow.com/questions/16864236/how-to-mark-line-numbers-in-javascript-ace-editor
            if (this.breakpoints) {
              editor.on("guttermousedown", function(e) {
                var target = e.domEvent.target; 
                if (target.className.indexOf("ace_gutter-cell") == -1)
                    return;
                if (e.clientX > 40 + target.getBoundingClientRect().left) 
                    return; 

                var row = e.getDocumentPosition().row;
                // Emit event
                self.$emit('gutterClick', row);
                e.stop();
                return false;
              });
            }
        },
        change(content) {
            this.$emit('change', content);
        },

        /*
         * Private methods
         */
        makeRange(sourceLocation) {
            return new Range(sourceLocation.startLine - 1, sourceLocation.startColumn, sourceLocation.endLine - 1, sourceLocation.endColumn);
        },

        /*
         * Public methods for parent (owner)
         */
        getSource() {
            return this.source;
        },
        setSource(source) {
            this.source = source;
        },
        /*
         * Marking
         */
        goToLine(line) {
          this.editor.gotoLine(line);
        },
        goToLocation(location) {
          this.goToLine(location.startLine - 1);
        },
        markInstruction(location) {
          var range = this.makeRange(location);
          this.instructionRangeMarkerId = this.editor.session.addMarker(
             range, "highlight-instruction-range", "text"
          );
          this.instructionLineMarkerId = this.editor.session.addMarker(
             range, "highlight-instruction-line", "fullLine"
          );
          this.goToLocation(location);
        },
        unmarkInstruction() {
          this.editor.session.removeMarker(this.instructionRangeMarkerId);
          this.editor.session.removeMarker(this.instructionLineMarkerId);
        },
        removeMarkers() {
           // unset error markers
           this.unsetError();
           this.unmarkInstruction();
           // unset other markers
           if (this.markers && this.markers.length) {
             for (var markerId of this.markers) {
               this.editor.session.removeMarker(markerId);
             }
             this.markers = [];
           }
        },
        unsetError() {
            if (this.errorRangeMarkerId) {
              this.editor.session.removeMarker(this.errorRangeMarkerId);
            }
            if (this.errorLineMarkerId) {
              this.editor.session.removeMarker(this.errorLineMarkerId);
            }
        },
        setError(codeError) {
          this.unsetError();
          if (codeError.location) {
             var range = this.makeRange(codeError.location);
             this.errorRangeMarkerId = this.editor.session.addMarker(
                range, "highlight-error-range", "text"
             );
             this.errorLineMarkerId = this.editor.session.addMarker(
                range, "highlight-error-line", "fullLine"
             );
             this.goToLocation(codeError.location);
          }
        },
        /*
         * Breakpoints marking
         */
        setBreakpoint(row) {
          this.editor.session.setBreakpoint(row);
        },
        clearBreakpoint(row) {
          this.editor.session.clearBreakpoint(row);
        },
        removeBreakpoints() {
          for (var row = 0; row < this.editor.session.doc.getAllLines().length; row++) {
            this.clearBreakpoint(row);
          }
        }
  }
}
</script>

<!-- non-scoped CSS for AceEditor styles -->
<style>
    .highlight-error-range {
        z-index: 20;
        position:absolute;
        border-bottom: 2px solid white;
    }
    .highlight-error-line {
        background:rgba(244,92,66,0.4);
        z-index: 20;
        position:absolute;
    }
    .highlight-instruction-range {
        background:rgba(66, 182, 244, 0.6);
        z-index: 20;
        position:absolute;
        //  border: 1px dashed white;
    }
    .highlight-instruction-line {
        background:rgba(66, 182, 244, 0.3);
        z-index: 20;
        position:absolute;
    }

    .ace_gutter-cell.ace_breakpoint{ 
        background-color: mediumvioletred;
        color: khaki;
    }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// AceEditor.vue?6a9f5060